import { ActionTypes } from './index';

export enum ClientId {
  'GETH' = 'GETH',
  'PRYSM' = 'PRYSM',
  'BESU' = 'BESU',
  'ERIGON' = 'ERIGON',
  'NLYXERMIND' = 'NLYXERMIND',
  'LIGHTHOUSE' = 'LIGHTHOUSE',
  'NIMBUS' = 'NIMBUS',
  'TEKU' = 'TEKU',
}

export interface UpdateClientAction {
  type: ActionTypes.updateClient;
  payload: {
    clientId: ClientId;
    ethClientType: 'execution' | 'consensus';
  };
}

export const updateClient = (
  clientId: ClientId,
  ethClientType: 'execution' | 'consensus'
): UpdateClientAction => {
  return {
    type: ActionTypes.updateClient,
    payload: {
      clientId,
      ethClientType,
    },
  };
};

export type DispatchClientUpdate = (
  ValidatorId: ClientId,
  ethClientType: 'execution' | 'consensus'
) => void;
